import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Grid } from '@mui/material';
import { m } from 'framer-motion';
import { styled } from '@mui/material/styles';
import MotionViewport from '../../animate/MotionViewport';
import ImgBox from '../Box/ImgBox';
import { dispatch } from '../../../redux/store';
import { getArticlesCO } from '../../../redux/slices/articles';
import ArticleCoTooltip from './ArticlesCoTooltip';
import useLocales from '../../../hooks/useLocales';

ArticlesCO.propTypes = {
  keyProp: PropTypes.string,
  locale: PropTypes.string,
};

export default function ArticlesCO({ keyProp, locale }) {
  const { translate } = useLocales();
  const [articleCO, setArticleCO] = useState({});
  const [authorRef, setAuthorRef] = useState(null);
  const [dateRef, setDateRef] = useState(null);

  const RootStyle = styled('div')(({ theme }) => ({
    padding: theme.spacing(2, 0),
    backgroundColor: theme.palette.background.paper,
  }));

  useEffect(() => {
    if (keyProp)
      dispatch(getArticlesCO({ key: keyProp, locale })).then((response) => {
        setArticleCO(response.data);
        setAuthorRef(response.data.attributes.find((item) => item.name === 'Author'));
        setDateRef(response.data.attributes.find((item) => item.name === 'Date'));
      });
  }, [keyProp, locale]);

  const pathCatalogue = window.location.pathname.includes('en/') ? `/en${translate('urls.co')}` : translate('urls.co');
  return (
    articleCO?.key && (
      <RootStyle className="printable">
        <Container component={MotionViewport} sx={{ height: '100%' }}>
          <m.div /* variants={varFade().inUp} */>
            <Grid container justifyContent="center">
              <Grid item xs={12} sx={{ maxWidth: 'fit-content !important', textAlign: 'end', position: 'relative' }}>
                <ImgBox
                  className="border-radius-top-12"
                  sx={{ maxWidth: '100%', margin: 'auto', maxHeight: '65vh' }}
                  src={
                    articleCO.thumbnail !== undefined && articleCO.thumbnail !== ''
                      ? `${process.env.REACT_APP_API_URL}/image/download/${articleCO.thumbnail}?sizeIndex=0`
                      : ''
                  }
                />
                <ArticleCoTooltip
                  name={`${articleCO.name}`}
                  author={authorRef?.values?.[0] ? `${translate('articles.author')}: ${authorRef?.values?.[0]}` : ''}
                  date={dateRef?.values?.[0] ? `${translate('articles.date')}: ${dateRef?.values?.[0]}` : ''}
                  link={`${pathCatalogue}/${articleCO.key}`}
                />
              </Grid>
            </Grid>
          </m.div>
        </Container>
      </RootStyle>
    )
  );
}
